<div class="basic-components">
    <h2>{{ title }}</h2>
    <h6>
        {{ description }}
    </h6>
</div>
